import { Stack, StackProps, styled } from '@mui/material';

import clsx from 'clsx';

import Button, { Props as ButtonProps } from '../../../../components/Button';
import { generateClasses } from '../../../../utils/helper';

export const pollsFormClasses = generateClasses('PollsForm', [
  'createPollButton',
  'pollListContainer',
  'pollAccordionGroup',
  'pollList',
]);

export const Content = styled((props: StackProps) => <Stack flex={1} gap={2} {...props} />)(({ theme }) => ({
  overflow: 'hidden',
  color: theme.palette.common.black,
  [`& .${pollsFormClasses.pollListContainer}`]: {
    overflow: 'hidden',
    flex: 1,
  },
}));

export const PollListContainer = styled(Stack)(({ theme }) => ({
  [`& .${pollsFormClasses.pollAccordionGroup}`]: {
    overflow: 'hidden',
  },
  [`& .${pollsFormClasses.pollList}`]: {
    overflow: 'auto',
  },
}));

export const CreatePollButton = styled((props: ButtonProps) => (
  <Button {...props} className={clsx(pollsFormClasses.createPollButton, props.className)} />
))(({ theme }) => ({
  [`&.${pollsFormClasses.createPollButton}`]: {
    ...theme.typography.h6Bold,
    justifyContent: 'flex-start',
    borderWidth: 0.5,
    borderRadius: 6,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
})) as typeof Button;
